module.exports = __webpack_public_path__ + "img/myphoto.8804a64a.png";